<template>
  <div
    class="row"
    style="margin-bottom: 5em">
    <div class="col-md-12">
      <b-button
        class="addRowButton"
        @click="addRow">
        {{ $t('message.lblAddRow') }}
      </b-button>
    </div>
    <div class="col-md-12">
      <hr>
      <b-button
        class="btn-primary"
        @click="save">{{ $t('message.lblSave') }}
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    addRow: {
      type: Function,
      addNewPrijemForm: Function,
      default: null,
    },
    save: {
      type: Function,
      save: Function,
      default: null,
    },
  },
};
</script>
